// extracted by mini-css-extract-plugin
module.exports =  {"unit":"var(--ring-unit)","popup":"DarkTooltip__popup--xw"};